<template>
	<q-layout :view="pageView">
		<LayoutHeader>
			<template slot="toolbar-buttons">
				<q-btn v-if="isTransferPage" flat dense icon="list" label="My Learning" @click="$router.push({ name: 'my-courses' })" />
				<q-btn v-if="isLearningPage" flat dense icon="playlist_add_check" count="unseenEquivalencyCount" label="Results" @click="onWmctClick()">
					<q-chip v-if="allEquivalencyCount > 0" floating color="red">{{ allEquivalencyCount }}</q-chip>
				</q-btn>
				<q-btn flat round dense icon="more_vert" class="q-ml-sm">
					<q-popover>
						<q-list separator link>
							<!--
							<q-item v-close-overlay tabindex="0">
								<q-icon name="help_outline" />
								&nbsp; Help
							</q-item>
							<q-item-separator />
							-->
							<q-item v-close-overlay
								@keyup.native.enter="deleteAllData"
								@click.native="deleteAllData" tabindex="0">
								<span style="white-space: nowrap">
								<q-icon name="delete" /> &nbsp;
								Clear Data
								</span>
							</q-item>
						</q-list>
					</q-popover>
				</q-btn>
			</template>
			<template slot="tabs" v-if="isLearningPage">
				<q-tabs
					:style="$q.theme === 'ios' ? { background: 'rgba(255,255,255,0.95' } : null">
					<q-route-tab hide="icon" icon="class" slot="title" to="/learning/my-courses" label="My Courses" />
					<q-route-tab hide="icon" icon="assessment" slot="title" to="/learning/my-assessments" label="My Assessments" />
				</q-tabs>
			</template>
		</LayoutHeader>

		<LayoutPageContainer />

		<LayoutFooter />

	</q-layout>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';
import LayoutHeader from '@/layouts/LayoutHeader.vue';
import LayoutFooter from '@/layouts/LayoutFooter.vue';
import LayoutPageContainer from '@/layouts/LayoutPageContainer.vue';
import { State } from '@/store';

@Component({
	methods: mapActions('wmct', [
		'checkinWithApi',
		'reset',
	]),
	computed: mapGetters('wmct', {
		unseenEquivalencyCount: 'getUnseenEquivalencyCount',
		allEquivalencyCount: 'getAllEquivalencyCount',
	}),
	components: { LayoutHeader, LayoutFooter, LayoutPageContainer },
})
export default class DefaultLayout extends Vue {
	private checkinWithApi!: () => Promise<void>;
	private reset!: () => void;
	private unseenEquivalencyCount!: number;
	private allEquivalencyCount!: number;

	public async mounted() {
		await this.checkinWithApi();
	}

	public onWmctClick() {
		this.$router.push({ name: 'will-my-credits-transfer' });
	}

	private async deleteAllData() {
		const self: any = this;
		const $q = self.$q;

		try {
			await $q.dialog({
				title: `Delete all data`,
				message: `Are you sure you want to delete all data stored on this device?`,
				color: 'secondary',
				ok: true,
				cancel: true,
			});

			this.reset();
		} catch (err) {
			// User dismissed dialog
		}
	}

	public get hasEquivalencyMapRun() {
		return this.$store.state.wmct.Transcript != null;
	}

	private get grabAttention() {
		return this.unseenEquivalencyCount > 0;
	}

	private get isHomePage() {
		return !this.isLearningPage && !this.isTransferPage;
	}

	private get isLearningPage() {
		return this.$route.path.startsWith('/learning');
	}

	private get isTransferPage() {
		return this.$route.path.startsWith('/transfer');
	}

	private get pageView() {
		return 'lhr lpr lfr';
	}
}
</script>

<style>
	.course-card .q-item-avatar, .assessment-card .q-item-avatar {
		border-radius: 0;
	}

	.course-card > .q-card-container, .assessment-card > .q-card-container {
		padding: 12px 16px 12px 16px;
	}

	.course-card.animated, .assessment-card.animated {
		-webkit-animation-duration: .333s !important;
		animation-duration: .333s !important;
	}

	#app .q-if-standard .q-if-label.q-if-label-above {
		font-size: 1rem;
		line-height: 1.5rem;
	}

	#app .q-field-helper {
		padding-bottom: 1rem;
	}

	::-webkit-scrollbar {
		height: 16px;
		overflow: visible;
		width: 8px;
	}

	::-webkit-scrollbar-button {
		height: 0;
		width: 0;
	}

	::-webkit-scrollbar-corner {
		background: transparent;
	}

	::-webkit-scrollbar-thumb {
		background-color: rgba(0,0,0,.2);
		background-clip: padding-box;
		border: solid transparent;
		border-width: 1px 1px 1px 0px;
		min-height: 28px;
		padding: 100px 0 0;
		-webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1), inset 0 -1px 0 rgba(0,0,0,.07);
		box-shadow: inset 1px 1px 0 rgba(0,0,0,.1), inset 0 -1px 0 rgba(0,0,0,.07);
	}

	::-webkit-scrollbar-track {
		background-clip: padding-box;
		border: solid transparent;
		border-width: 0 0 0 4px;
	}
</style>
